export const computePollInterval = ({ expiry, expiryMarginMs, defaultPollIntervalMs, stalePollIntervalMs, now = Date.now(), }) => {
    if (expiry === undefined)
        return defaultPollIntervalMs;
    const msUntilRefresh = expiry - now - expiryMarginMs;
    return msUntilRefresh > 0 ? msUntilRefresh : stalePollIntervalMs;
};
